import { parseLineageUrns } from './parseLineageUrns';
export const PREDEFINED_LINEAGE_URN_PATTERN = /^urn:adsk\.\w+:dm\.lineage:[\w-]+$/;
export const PREDEFINED_LINEAGE_MAX_UPLOAD_BYTES = 20 * 1024 * 1024;
const MAX_DOCUMENT_JOBS_PER_SHARD = 1000;
const WORKER_MAX_LINEAGES_PER_COLLECTION_JOB = 5000;
export const DEFAULT_PREDEFINED_LINEAGE_BATCH_SIZE = 3;
function dedupe(urns) {
    return [...new Set(urns)];
}
export function parsePredefinedLineageText(raw) {
    const tokens = dedupe(parseLineageUrns(raw));
    const lineages = [];
    const invalidUrns = [];
    for (const urn of tokens) {
        if (PREDEFINED_LINEAGE_URN_PATTERN.test(urn)) {
            lineages.push(urn);
        }
        else {
            invalidUrns.push(urn);
        }
    }
    return { lineages, invalidUrns };
}
function computeLineagesPerShard(lineageValidationBatchSize) {
    const batchSize = Math.max(1, Math.floor(lineageValidationBatchSize));
    return Math.min(WORKER_MAX_LINEAGES_PER_COLLECTION_JOB, batchSize * MAX_DOCUMENT_JOBS_PER_SHARD);
}
export function planPredefinedLineageSummary(totalLineages, lineageValidationBatchSize = DEFAULT_PREDEFINED_LINEAGE_BATCH_SIZE) {
    const lineagesPerShard = computeLineagesPerShard(lineageValidationBatchSize);
    const batchSize = Math.max(1, Math.floor(lineageValidationBatchSize));
    return {
        totalLineages,
        lineagesPerShard,
        shardCount: totalLineages <= 0 ? 0 : Math.ceil(totalLineages / lineagesPerShard),
        estimatedDocumentJobs: totalLineages <= 0 ? 0 : Math.ceil(totalLineages / batchSize),
    };
}
